// Initialize theme from localStorage
export const initializeTheme = () => {
  const savedTheme = localStorage.getItem('theme');
  const savedColorScheme = localStorage.getItem('colorScheme');
  
  if (savedTheme || savedColorScheme) {
    const themes = {
      hydrogen: {
        colors: {
          primary: '#3B82F6',
          secondary: '#60A5FA',
          accent: '#2563EB',
          background: '#F3F4F6',
          surface: '#FFFFFF',
          text: '#1F2937',
          border: '#E5E7EB'
        }
      },
      helium: {
        colors: {
          primary: '#8B5CF6',
          secondary: '#A78BFA',
          accent: '#7C3AED',
          background: '#F9FAFB',
          surface: '#FFFFFF',
          text: '#111827',
          border: '#E5E7EB'
        }
      },
      lithium: {
        colors: {
          primary: '#14B8A6',
          secondary: '#2DD4BF',
          accent: '#0D9488',
          background: '#F0FDFA',
          surface: '#FFFFFF',
          text: '#134E4A',
          border: '#E6FFFA'
        }
      },
      beryllium: {
        colors: {
          primary: '#F59E0B',
          secondary: '#FCD34D',
          accent: '#D97706',
          background: '#FFFBEB',
          surface: '#FFFFFF',
          text: '#78350F',
          border: '#FEF3C7'
        }
      },
      boron: {
        colors: {
          primary: '#F43F5E',
          secondary: '#FB7185',
          accent: '#E11D48',
          background: '#FFF1F2',
          surface: '#FFFFFF',
          text: '#881337',
          border: '#FECDD3'
        }
      },
      carbon: {
        colors: {
          primary: '#374151',
          secondary: '#6B7280',
          accent: '#1F2937',
          background: '#F9FAFB',
          surface: '#FFFFFF',
          text: '#111827',
          border: '#E5E7EB'
        }
      }
    };

    const colorSchemes = {
      blue: '#3B82F6',
      black: '#000000',
      teal: '#14B8A6',
      violet: '#8B5CF6',
      rose: '#F43F5E',
      yellow: '#F59E0B'
    };
    
    const theme = themes[savedTheme || 'hydrogen'];
    const colorScheme = colorSchemes[savedColorScheme || 'blue'];
    
    if (theme) {
      const root = document.documentElement;
      Object.entries(theme.colors).forEach(([key, value]) => {
        root.style.setProperty(`--color-${key}`, value);
      });
      
      // Override primary color with selected color scheme
      if (colorScheme) {
        root.style.setProperty('--color-primary', colorScheme);
        root.style.setProperty('--color-primary-hover', colorScheme + 'dd');
      }
    }
  }
};

// Call on page load
initializeTheme();